export const TASK_STATUS = {
  COMPLETE: 1,
  INCOMPLETE: 2,
};

export const TASK_STATUS_LABEL = {
  [TASK_STATUS.COMPLETE]: "完了",
  [TASK_STATUS.INCOMPLETE]: "完了",
};
